/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Bills_ExpensesInputs */

const en_nav_bills_expenses = /** @type {(inputs: Nav_Bills_ExpensesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bills & Expenses`)
};

const es_nav_bills_expenses = /** @type {(inputs: Nav_Bills_ExpensesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturas y gastos`)
};

/**
* | output |
* | --- |
* | "Bills & Expenses" |
*
* @param {Nav_Bills_ExpensesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_bills_expenses = /** @type {((inputs?: Nav_Bills_ExpensesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Bills_ExpensesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_bills_expenses(inputs)
	return es_nav_bills_expenses(inputs)
});